import { useQuery } from "react-query";

import { mapBrandingSettings } from "mappers";
import { brandingService } from "services";

const useBrandingSettingsAgentOfficeQuery = ({
	companyId,
	onSuccess,
}: {
	companyId: string;
	onSuccess: Function;
}) => {
	const queryResult = useQuery(
		["brandingSettingsAgentOffice", companyId],
		() => brandingService.getBrandingSettingsAgentOffice({ companyId }),
		{
			retry: 0,
			cacheTime: 0,
			enabled: !!companyId,
			select: mapBrandingSettings,
			onSuccess(result) {
				onSuccess?.(result?.publicLogoUrl);
			},
		},
	);

	return queryResult;
};

export default useBrandingSettingsAgentOfficeQuery;
